import { Checkout } from '@public/Showroom/Checkout'

Checkout.seoProps = {
  description:
    'Review your order, choose contact information and select billing and shipping address.',
}

export default Checkout
